import { render, staticRenderFns } from "./DisplayBrowser.vue?vue&type=template&id=56d7ce5f&scoped=true"
import script from "./DisplayBrowser.vue?vue&type=script&lang=ts"
export * from "./DisplayBrowser.vue?vue&type=script&lang=ts"
import style0 from "./DisplayBrowser.vue?vue&type=style&index=0&id=56d7ce5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d7ce5f",
  null
  
)

export default component.exports